// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3Exc-","file":"styles_file__2kNVZ"};